import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { useCallback, useEffect, useState } from 'react';

export const useSidebarAutoScroll = (): ((el: HTMLElement | null) => void) => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if (!element) return;
    return autoScrollForElements({ element });
  }, [element]);
  return useCallback((el: HTMLElement | null) => {
    setElement(el);
  }, []);
};
